import { checkoutTotalsView } from './checkout'
import { getDepositAmount } from './deposit'
import createSelector from 'lib/web/createSelector'
import { isDepositSelected, isInstalmentsSelected } from 'checkout/selectors/payment/paymentType'

export const getGrandTotal = (state: App.State) => checkoutTotalsView(state).data.grandTotal

export const getCreditBalanceForCheckoutCurrency = (state: App.State) =>
  state.auth.account.creditsByCurrency[state.checkout.cart.currencyCode]?.balance ?? 0

export function calculateValue(price: number, discountPercentage: number) {
  const priceFraction = 1 - (discountPercentage / 100)
  if (priceFraction === 0) { return 0 }
  return price / priceFraction
}

export function calculateDiscount(price: number, value: number) {
  if (value === 0) { return 0 }
  const discountFraction = 1 - (price / value)
  return Math.round(100 * discountFraction)
}

export const getPaymentAmount = createSelector(
  (state: App.State) => isDepositSelected(state),
  getDepositAmount,
  checkoutTotalsView,
  (state: App.State) => isInstalmentsSelected(state),
  (isDepositSelected,
    depositAmount,
    totals,
    isInstalmentsSelected,
  ) => {
    if (isDepositSelected || isInstalmentsSelected) return depositAmount
    return totals.data.payableNow
  },
)
